import BaseAPI from "./BaseAPI";
import { URLS } from "./Endpoints";
import { GenericAPI } from "./GenericAPI";

class FlowAPI extends GenericAPI {

  /**
   * Request que busca locker por uuid
   * @param  {string} uuid - uuid do usuário
   */
  static async get(uuid: string) {
    try {
      const response = await BaseAPI.get(`${URLS.FLOW}/${uuid}`);
      if (response.status === 200) return response.data;
      return { error: "Erro ao buscar fluxo." };
    } catch (e) {
      return this._exception(e, "Falha ao buscar fluxo.");
    }
  }

  /**
   * Request que avalia experência de alocação
   * @param  {EvaluateAllocationPayloadModel} data - payload data
   */
  static async evaluateAllocation(data: EvaluateAllocationPayloadModel) {
    try {
      const response = await BaseAPI.post(
        `${URLS.FLOW}/allocation-evaluation`,
        data,
      );
      if (response.status === 200) return response.data;
      return { error: "Erro ao avaliar fluxo." };
    } catch (e) {
      return this._exception(e, "Falha ao buscar fluxo.");
    }
  }
}

export default FlowAPI;
